define("tmds/symbols/TextSymbol", [
	"jquery",
	"./Font",
	"./Symbol",
	"./utils",
    "../validator"
], function($, Font, Symbol, utils, validator) {
	"use strict";
	
	/**
	 * construct a new TextSymbol
	 * @param options {Object} option object with below structure
	 * 		{
	 * 			text: "a string",
	 * 			color: [255,0,0,0.5],
	 * 			anchor: "middle",
	 * 			font: {
	 * 				family: "serif",
	 * 				size: 12,
	 * 				style: "normal",
	 * 				weight: "bold"
	 * 			}
	 * 		}
	 * @note all option members are optional
	 * @see {tmds.symbols.Font} for font details
	 */
	var TextSymbol = function(options) {
		
		Symbol.call(this, options);
		
		// default text symbol settings
		this.text = "";
		this.color = [0,0,0,1];
		this.font = new Font();
		this.anchor = 'middle';
		this.xOffset = 0;
		this.yOffset = 0;
		
		if (options) {
			
			if (validator.isDataObject(options)) {
				
				if(options.text != undefined) 
					setText.call(this, options.text);
					
				if(options.color != undefined) 
					setColor.call(this, options.color);
				
				if(options.anchor != undefined) 
					setAnchor.call(this, options.anchor);
				
				if(options.xOffset != undefined || options.yOffset != undefined)
					setOffset.call(this, options.xOffset, options.yOffset);
					
				if(options.font != undefined)
					setFont.call(this, options.font);
			}
			else if (validator.isString(options)) {
				this.text = options;
			}
			else {
			 	throw new Error('Invalid options values - ' + options + ' passed');
		 	}
		}
	};
	
	/**
	 * set the text color
	 * @param color {Array} [r,g,b,a]
	 * @return the symbol itself
	 */
	function setColor(color) {
		
		var _color = utils.toColorArray(color);

		if(_color === false) {
			
			throw new Error('Invalid color value - ' + color + ' passed');
		}
		
		this.color = _color;
		return this;
	}
	
	/**
	 * set the text symbol anchor
	 * @param anchor {String}
	 * @return the symbol itself
	 */
	function setAnchor(anchor) {
		
		if(! validator.isValidAnchor(anchor)) {
			
			throw new Error('Invalid anchor value - ' + anchor + ' passed');
		}
		
		this.anchor = anchor;
		return this;
	}
	
	/**
	 * set the text font
	 * @param font {tmds.symbols.Font}
	 * @return the symbol itself
	 */
	function setFont(font) {
		
		if(! validator.isDataObject(font)) {
			
			throw new Error('Invalid font value - ' + font + ' passed');
		}
		
		this.font = new Font(font);
		
		return this;			
	}
	
	/**
	 * set the text string
	 * @param text {String} new text
	 * @return the symbol itself
	 */
	function setText(text) {
		
		if(! validator.isString(text)) {
			
			throw new Error('Invalid Text value - ' + text + ' passed');
		}
		
		this.text = text;
		return this;
	}
	
	/**
	 * set the symbol offset
	 * @param x {Number} new x offset value
	 * @param y {Number} new y offset value
	 * @return the symbol itself
	 */
	function setOffset(x, y) {
		
		var validX = validator.isNumber(x),
			validY = validator.isNumber(y);
		
		if((x != undefined && ! validX) || (y != undefined && ! validY) || (x == undefined && y == undefined)) {
			
			throw new Error('Invalid xOffset, yOffset values - ' + x  + ' , ' + y + ' passed');
		}
		
		if(validX) this.xOffset = Number(x);
		
		if(validY) this.yOffset = Number(y);
		
		return this;
	}
	
	/**
	 * convert TextSymbol object to JSON representation
	 */
	function toJson() {
		return {
			type: this.type,
			text: this.text,
			color: this.color,
			font: this.font.toJson(),
			anchor: this.anchor,
			xOffset: this.xOffset,
			yOffset: this.yOffset
		};
	}
		
	// TextSymbol inherits Symbol with some extensions
	TextSymbol.prototype = $.extend(Object.create(Symbol.prototype), {
		
		declaredClass: "tmds.symbols.TextSymbol",
		type: "TextSymbol",
		'setColor' : setColor,
		'setAnchor' : setAnchor,
		'setFont' : setFont,
		'setText' : setText,
		'setOffset' : setOffset,
		'toJson' : toJson
	});
	
	return TextSymbol;
});